import { render, staticRenderFns } from "./CustomizeBeoModal.vue?vue&type=template&id=13a3d6bf&scoped=true"
import script from "./CustomizeBeoModal.vue?vue&type=script&lang=ts"
export * from "./CustomizeBeoModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomizeBeoModal.vue?vue&type=style&index=0&id=13a3d6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3d6bf",
  null
  
)

export default component.exports